import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faTruckFast,
  faBoxOpen,
  faShieldAlt,
  faClock,
  faGlobe,
  faMoneyBillWave,
} from "@fortawesome/free-solid-svg-icons";
import "./deliveryDetails.css";
import { useEffect } from "react";
import { Helmet } from "react-helmet";


export default function DeliveryDetails() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Helmet>
        <title>SHOP.CO | Delivery Details - Shipping Information</title>
        <meta
          name="description"
          content="Find all the details about SHOP.CO delivery and shipping options. Learn about estimated times, costs, and international availability."
        />

        <link
          rel="canonical"
          href="https://shop-co-roan.vercel.app/help/delivery-details/"
        />
      </Helmet>

      <div className="deliveryDetails-container">
        <header className="deliveryDetails-header">
          <h1>Delivery Information</h1>
          <p>Everything you need to know about shipping, delivery times, and policies.</p>
        </header>

        <div className="deliveryDetails-sections">
          <div className="deliveryDetails-card">
            <FontAwesomeIcon icon={faTruckFast} className="deliveryDetails-icon" />
            <h3>Fast Shipping</h3>
            <p>We offer same-day shipping for orders placed before 12 PM. Most orders arrive within 2-5 business days.</p>
          </div>

          <div className="deliveryDetails-card">
            <FontAwesomeIcon icon={faBoxOpen} className="deliveryDetails-icon" />
            <h3>Packaging</h3>
            <p>All products are safely packed with eco-friendly materials to ensure minimal damage and sustainability.</p>
          </div>

          <div className="deliveryDetails-card">
            <FontAwesomeIcon icon={faShieldAlt} className="deliveryDetails-icon" />
            <h3>Secure Delivery</h3>
            <p>We partner with trusted courier services to ensure your order reaches you securely and on time.</p>
          </div>

          <div className="deliveryDetails-card">
            <FontAwesomeIcon icon={faClock} className="deliveryDetails-icon" />
            <h3>Delivery Hours</h3>
            <p>Deliveries are made between 9 AM – 9 PM on working days. Weekend deliveries are also available in major cities.</p>
          </div>

          <div className="deliveryDetails-card">
            <FontAwesomeIcon icon={faGlobe} className="deliveryDetails-icon" />
            <h3>International Shipping</h3>
            <p>We ship to over 100 countries worldwide with clear tracking and reliable delivery times.</p>
          </div>

          <div className="deliveryDetails-card">
            <FontAwesomeIcon icon={faMoneyBillWave} className="deliveryDetails-icon" />
            <h3>Cash on Delivery</h3>
            <p>Prefer paying on delivery? We offer COD in selected areas for your convenience and peace of mind.</p>
          </div>
        </div>
      </div>
    </>
  );
}
